import script from "./ContactRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactRequestsPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactRequestsPage.vue?vue&type=style&index=0&id=52b3967f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b3967f"]])

export default __exports__